<script lang="ts">
	import Link from "./Link.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";

	export let reverseOrder = false;
	export let headline = "";
	export let description = "";
	export let tryApp = "";
	export let imgUrl = "";
	export let href = "";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div
	class="mx-auto flex flex-col-reverse items-center justify-center gap-8 lg:flex-row lg:gap-16"
	class:lg:flex-row-reverse={reverseOrder}
>
	<div class="max-w-xl lg:min-w-96">
		<h2 class="text-primary text-md leading-[1.1] lg:text-lg">{@html headline}</h2>
		<p>{@html description}</p>
		<Link variant="primary" asButton {href} class="mt-4 lg:mt-8">
			{@html tryApp}
		</Link>
	</div>
	<div class="xl:shrink-0">
		<StaticPicture width={548} height={201} image={imgUrl} alt={headline} />
	</div>
</div>
